var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessDenied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 234,
    height: 199,
    viewBox: "0 0 234 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_65511",
    x: 144.269,
    y: 91.688,
    width: 34.752,
    height: 57.454,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_231",
    x: 146.003,
    y: 132.357,
    width: 31.5,
    height: 31.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_65512",
    x: 55.003,
    y: 54.357,
    width: 119.13,
    height: 96.407,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53057",
    "data-name": "Group 53057",
    transform: "translate(-567 -243.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53044",
    "data-name": "Group 53044",
    transform: "translate(0 -40.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53032",
    "data-name": "Group 53032",
    transform: "translate(10 -54.747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52924",
    "data-name": "Group 52924",
    transform: "translate(459 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52922",
    "data-name": "Group 52922",
    transform: "translate(-33 -90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52921",
    "data-name": "Group 52921",
    transform: "translate(149.083 439)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_230",
    "data-name": "Ellipse 230",
    cx: 99.5,
    cy: 99.5,
    r: 99.5,
    transform: "translate(-0.083)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51884",
    "data-name": "Group 51884",
    transform: "translate(131 454.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51882",
    "data-name": "Group 51882"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(19 16.699)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(0 -0.301)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51883",
    "data-name": "Group 51883",
    transform: "translate(194.739 58.422)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211-2",
    "data-name": "Ellipse 211",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(19.261 16.277)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_212-2",
    "data-name": "Ellipse 212",
    cx: 4,
    cy: 3.5,
    rx: 4,
    ry: 3.5,
    transform: "translate(0.261 0.277)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52923",
    "data-name": "Group 52923",
    transform: "translate(114.025 487.324) rotate(-59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51882-2",
    "data-name": "Group 51882",
    transform: "translate(173.188 54.041)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_211-3",
    "data-name": "Ellipse 211",
    cx: 9.5,
    cy: 9.5,
    rx: 9.5,
    ry: 9.5,
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_212-3",
    "data-name": "Ellipse 212",
    cx: 3.5,
    cy: 3.5,
    rx: 3.5,
    ry: 3.5,
    transform: "translate(31 29)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51883-2",
    "data-name": "Group 51883",
    transform: "translate(-9.429 5.665)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_211-4",
    "data-name": "Ellipse 211",
    cx: 10,
    cy: 10,
    rx: 10,
    ry: 10,
    transform: "translate(0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_212-4",
    "data-name": "Ellipse 212",
    cx: 3.5,
    cy: 3.5,
    rx: 3.5,
    ry: 3.5,
    transform: "translate(22.425 28.319)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_25",
    transform: "translate(628.253 296)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -61.25, -52.61)",
    filter: "url(#Path_65511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65511-2",
    "data-name": "Path 65511",
    d: "M74.011,40.9,67.7,68.688a1.613,1.613,0,0,1-1.574,1.266,1.631,1.631,0,0,1-1.591-1.266L58.219,40.9a8.1,8.1,0,1,1,15.792,0Z",
    transform: "translate(95.53 66.94)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -61.25, -52.61)",
    filter: "url(#Ellipse_231)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_231-2",
    "data-name": "Ellipse 231",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(155.25 138.61)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53056",
    "data-name": "Group 53056",
    transform: "translate(3 8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -64.25, -60.61)",
    filter: "url(#Path_65512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65512-2",
    "data-name": "Path 65512",
    d: "M95.515,8h-84.4A8.118,8.118,0,0,0,3,16.115V77.792a8.118,8.118,0,0,0,8.115,8.115h82.03a9.963,9.963,0,0,1,2.548-2.029.791.791,0,0,1-.049-.114L89.331,55.945A11.344,11.344,0,0,1,100.4,42.084a11.735,11.735,0,0,1,3.214.454V40.526c0-.032.016-.049.016-.065V16.115A8.129,8.129,0,0,0,95.515,8Zm-18,35.042a3.246,3.246,0,0,1-2.289,5.535,3.228,3.228,0,0,1-2.3-.958l-2.564-2.564-2.581,2.564a3.313,3.313,0,0,1-4.593,0,3.252,3.252,0,0,1,0-4.577l2.581-2.581-2.581-2.581A3.242,3.242,0,0,1,67.776,33.3l2.581,2.564L72.922,33.3a3.242,3.242,0,0,1,4.593,4.577L74.95,40.461ZM28.969,14.492a1.623,1.623,0,1,1-1.623,1.623A1.628,1.628,0,0,1,28.969,14.492Zm-8.115,0a1.623,1.623,0,1,1-1.623,1.623A1.628,1.628,0,0,1,20.854,14.492Zm-8.115,0a1.623,1.623,0,1,1-1.623,1.623A1.628,1.628,0,0,1,12.738,14.492ZM6.246,24.231V20.985H66.3a1.623,1.623,0,0,1,0,3.246ZM29.1,37.881A3.242,3.242,0,0,1,33.692,33.3l2.581,2.564L38.837,33.3a3.242,3.242,0,0,1,4.593,4.577l-2.564,2.581,2.564,2.581a3.246,3.246,0,0,1-2.289,5.535,3.228,3.228,0,0,1-2.3-.958l-2.564-2.564-2.581,2.564a3.313,3.313,0,0,1-4.593,0,3.252,3.252,0,0,1,0-4.577l2.581-2.581Zm56.126,33.6a3.228,3.228,0,0,1-4.5.893,49.291,49.291,0,0,0-54.827,0,3.2,3.2,0,0,1-1.8.536,3.207,3.207,0,0,1-3.181-3.863,3.107,3.107,0,0,1,1.38-2.061,55.764,55.764,0,0,1,62.034,0,3.235,3.235,0,0,1,.893,4.5Zm3.8-47.247H72.792a1.623,1.623,0,1,1,0-3.246H89.022a1.623,1.623,0,0,1,0,3.246Zm11.361,0H95.515a1.623,1.623,0,1,1,0-3.246h4.869Z",
    transform: "translate(61.25 52.61)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDenied);
export default __webpack_public_path__ + "static/media/accessDenied.15145becb5cbe5aeff7f113694ae44c5.svg";
export { ForwardRef as ReactComponent };